import AudioManager from "../../../manager/audio_manager";


export default class TexasSound {
    static path:string = 'package/texasholdem/sound/';

    //背景音乐
    static playBg(){
        AudioManager.instance.playMusic(this.path + 'bgm/dezhou', false);
    }

    //暂停音乐
    static stopSound(audioID:number){
        cc.audioEngine.stop(audioID);
    }
    
    static playSound(name:string){
        AudioManager.instance.playSound(TexasSound.path + name, false, null)
    }

    //弃牌
    static playFold(){
        TexasSound.playSound('fold');
    }

    //发牌
    static playDealCard(){
        TexasSound.playSound('dealcard');
    }


    //倒计时
    static playCountDownTime(){
        return TexasSound.playSound('countdown');
    }

    //让牌
    static playCheck(){
        TexasSound.playSound('check');
    }

    //翻牌
    static playTurnOver(){
        TexasSound.playSound('fanpai');
    }
    //胜利
    static playWin(){
        TexasSound.playSound('win');
    }

    //公牌翻牌
    static playTurnCommon(){
        TexasSound.playSound('commonTurn')
    }

    //开始下注,筹码声音
    static playBeginBet(){
        TexasSound.playSound('beginBet');
    }

    //下注 加注
    static playBet(){
        TexasSound.playSound('bet');
    }

    //回合结束收筹码
    static playReceiveBet(){
        TexasSound.playSound('receiveBet')
    }

    //同花顺以上胜利音效
    static playWinEx(){
        TexasSound.playSound('winEx');
    }

    //入座
    static playSeat(){
        TexasSound.playSound('seat');
    }

    //结算飞筹码
    static playFlyBet(){
        TexasSound.playSound('endBet');
    }

    //翻牌
    static playRotatePoker(){
        TexasSound.playSound('commPoker');
    }

    static playWeel(){
        TexasSound.playSound('weel');
    }

    static playGoldMove(){
        TexasSound.playSound('choumamove');
    }

    static winOpen(){
        TexasSound.playSound('winopen');
    }

    static winClose(){
        TexasSound.playSound('winclose');
    }

    static clockend(){
        TexasSound.playSound('clockend');
    }

    static bipaiwin(){
        TexasSound.playSound('bipaiwin');
    }

    static bipailose(){
        TexasSound.playSound('bipailose');
    }

    static allinSound(){
        TexasSound.playSound('allin');
    }
}
